<template>
  <div class="article">
    <div v-if="show">
<!--      <h3 class="h3">{{ article.title }}</h3>-->
      <div class="content" v-html="article.content"></div>
    </div>

    <Laod ref="laoding" />
    <Floating />
    <wxShare />
  </div>
</template>

<script>
  import { Cell  } from 'vant';

  export default {
    components: {
      [Cell.name]: Cell
    },
    name: 'article_details',
    data() {
      return {
        show: false,
        article: [],
      };
    },
    created() {
      this.getDetails()
    },
    methods: {
      getDetails() {
        const regex = new RegExp('<img', 'gi')
        this.$api.get('article/details', {id: this.$route.query.id}, r=>{
          this.article = r.data
          document.title = this.article.title
          let content = this.article.content
          this.article.content = content.replace(regex, `<img style="max-width: 100%; height: auto;display: block;"`)
          this.show = true
          this.$refs.laoding.loadClose()
        })
      }
    }
  }
</script>

<style scoped>
  .article{
    width: 100%;
    height: 100%;
    background-color: #ffffff;
    overflow: hidden;
  }
  .article .h3{
    text-align: center;
    font-size: 16px;
  }
  .article .content{
  }
  .article .content img{
    display: block;
    max-width: 100% !important;
  }
  .article .content p{
    margin: 0;
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/index/details.vue